// ============================================================================= //
//  JS detection
// ============================================================================= //
document.body.classList.remove("no-js");

// ============================================================================= //
//  Modules
// ============================================================================= //
import "./modules/smooth-scroll";
import "./modules/site-header";
import "./modules/mobile-navigation";
import "./modules/site-search";
import "./modules/animations";
import "./modules/swiper";


